export default __webpack_public_path__ + "caee9fe7eaa07b4fa91d1ca68a8b87ed.png";